/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminPartnersResponse,
  GetAdminPartnersParams,
  GetPartnerIdByUrlParamParams,
  HTTPValidationError,
  PartnerDetails,
  PartnerIdByParamResponse,
} from './platformapi.schemas';

import getAdminPartnersMutator from '../custom-axios-instance';
import createImpactPartnerMutator from '../custom-axios-instance';
import getPartnerIdByUrlParamMutator from '../custom-axios-instance';
import getImpactPartnerUpdateMutator from '../custom-axios-instance';
import updatePartnerMutator from '../custom-axios-instance';

/**
 * @summary Get Admin Partners
 */
export const getAdminPartners = (params?: GetAdminPartnersParams, signal?: AbortSignal) => {
  return getAdminPartnersMutator<AdminPartnersResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/partners/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAdminPartnersQueryKey = (params?: GetAdminPartnersParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/partners/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminPartnersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminPartners>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminPartnersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminPartnersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPartners>>> = ({ signal }) =>
    getAdminPartners(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPartners>>>;
export type GetAdminPartnersQueryError = void | HTTPValidationError;

export function useGetAdminPartners<
  TData = Awaited<ReturnType<typeof getAdminPartners>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetAdminPartnersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPartners>>,
          TError,
          Awaited<ReturnType<typeof getAdminPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminPartners<
  TData = Awaited<ReturnType<typeof getAdminPartners>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminPartnersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPartners>>,
          TError,
          Awaited<ReturnType<typeof getAdminPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminPartners<
  TData = Awaited<ReturnType<typeof getAdminPartners>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminPartnersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Admin Partners
 */

export function useGetAdminPartners<
  TData = Awaited<ReturnType<typeof getAdminPartners>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminPartnersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminPartnersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Impact Partner
 */
export const createImpactPartner = (partnerDetails: PartnerDetails, signal?: AbortSignal) => {
  return createImpactPartnerMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/partners/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: partnerDetails,
    signal,
  });
};

export const getCreateImpactPartnerMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createImpactPartner>>,
    TError,
    { data: PartnerDetails },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createImpactPartner>>,
  TError,
  { data: PartnerDetails },
  TContext
> => {
  const mutationKey = ['createImpactPartner'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createImpactPartner>>,
    { data: PartnerDetails }
  > = (props) => {
    const { data } = props ?? {};

    return createImpactPartner(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateImpactPartnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createImpactPartner>>
>;
export type CreateImpactPartnerMutationBody = PartnerDetails;
export type CreateImpactPartnerMutationError = void | HTTPValidationError;

/**
 * @summary Create Impact Partner
 */
export const useCreateImpactPartner = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createImpactPartner>>,
      TError,
      { data: PartnerDetails },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createImpactPartner>>,
  TError,
  { data: PartnerDetails },
  TContext
> => {
  const mutationOptions = getCreateImpactPartnerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Partner Id By Url Param
 */
export const getPartnerIdByUrlParam = (
  params: GetPartnerIdByUrlParamParams,
  signal?: AbortSignal,
) => {
  return getPartnerIdByUrlParamMutator<PartnerIdByParamResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/partners/partner_id-by-url-param`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetPartnerIdByUrlParamQueryKey = (params: GetPartnerIdByUrlParamParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/partners/partner_id-by-url-param`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPartnerIdByUrlParamQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerIdByUrlParam>>,
  TError = void | HTTPValidationError,
>(
  params: GetPartnerIdByUrlParamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerIdByUrlParam>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPartnerIdByUrlParamQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerIdByUrlParam>>> = ({ signal }) =>
    getPartnerIdByUrlParam(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerIdByUrlParam>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPartnerIdByUrlParamQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerIdByUrlParam>>
>;
export type GetPartnerIdByUrlParamQueryError = void | HTTPValidationError;

export function useGetPartnerIdByUrlParam<
  TData = Awaited<ReturnType<typeof getPartnerIdByUrlParam>>,
  TError = void | HTTPValidationError,
>(
  params: GetPartnerIdByUrlParamParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerIdByUrlParam>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerIdByUrlParam>>,
          TError,
          Awaited<ReturnType<typeof getPartnerIdByUrlParam>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPartnerIdByUrlParam<
  TData = Awaited<ReturnType<typeof getPartnerIdByUrlParam>>,
  TError = void | HTTPValidationError,
>(
  params: GetPartnerIdByUrlParamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerIdByUrlParam>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerIdByUrlParam>>,
          TError,
          Awaited<ReturnType<typeof getPartnerIdByUrlParam>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPartnerIdByUrlParam<
  TData = Awaited<ReturnType<typeof getPartnerIdByUrlParam>>,
  TError = void | HTTPValidationError,
>(
  params: GetPartnerIdByUrlParamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerIdByUrlParam>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Partner Id By Url Param
 */

export function useGetPartnerIdByUrlParam<
  TData = Awaited<ReturnType<typeof getPartnerIdByUrlParam>>,
  TError = void | HTTPValidationError,
>(
  params: GetPartnerIdByUrlParamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerIdByUrlParam>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerIdByUrlParamQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Impact Partner Update
 */
export const getImpactPartnerUpdate = (partnerId: number, signal?: AbortSignal) => {
  return getImpactPartnerUpdateMutator<PartnerDetails>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/partners/update/${partnerId}`,
    method: 'GET',
    signal,
  });
};

export const getGetImpactPartnerUpdateQueryKey = (partnerId: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/partners/update/${partnerId}`] as const;
};

export const getGetImpactPartnerUpdateQueryOptions = <
  TData = Awaited<ReturnType<typeof getImpactPartnerUpdate>>,
  TError = void | HTTPValidationError,
>(
  partnerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImpactPartnerUpdate>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImpactPartnerUpdateQueryKey(partnerId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImpactPartnerUpdate>>> = ({ signal }) =>
    getImpactPartnerUpdate(partnerId, signal);

  return { queryKey, queryFn, enabled: !!partnerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getImpactPartnerUpdate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetImpactPartnerUpdateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImpactPartnerUpdate>>
>;
export type GetImpactPartnerUpdateQueryError = void | HTTPValidationError;

export function useGetImpactPartnerUpdate<
  TData = Awaited<ReturnType<typeof getImpactPartnerUpdate>>,
  TError = void | HTTPValidationError,
>(
  partnerId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImpactPartnerUpdate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImpactPartnerUpdate>>,
          TError,
          Awaited<ReturnType<typeof getImpactPartnerUpdate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImpactPartnerUpdate<
  TData = Awaited<ReturnType<typeof getImpactPartnerUpdate>>,
  TError = void | HTTPValidationError,
>(
  partnerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImpactPartnerUpdate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImpactPartnerUpdate>>,
          TError,
          Awaited<ReturnType<typeof getImpactPartnerUpdate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImpactPartnerUpdate<
  TData = Awaited<ReturnType<typeof getImpactPartnerUpdate>>,
  TError = void | HTTPValidationError,
>(
  partnerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImpactPartnerUpdate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Impact Partner Update
 */

export function useGetImpactPartnerUpdate<
  TData = Awaited<ReturnType<typeof getImpactPartnerUpdate>>,
  TError = void | HTTPValidationError,
>(
  partnerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImpactPartnerUpdate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetImpactPartnerUpdateQueryOptions(partnerId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Partner
 */
export const updatePartner = (
  partnerId: number,
  partnerDetails: PartnerDetails,
  signal?: AbortSignal,
) => {
  return updatePartnerMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/partners/update/${partnerId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: partnerDetails,
    signal,
  });
};

export const getUpdatePartnerMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePartner>>,
    TError,
    { partnerId: number; data: PartnerDetails },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePartner>>,
  TError,
  { partnerId: number; data: PartnerDetails },
  TContext
> => {
  const mutationKey = ['updatePartner'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePartner>>,
    { partnerId: number; data: PartnerDetails }
  > = (props) => {
    const { partnerId, data } = props ?? {};

    return updatePartner(partnerId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof updatePartner>>>;
export type UpdatePartnerMutationBody = PartnerDetails;
export type UpdatePartnerMutationError = void | HTTPValidationError;

/**
 * @summary Update Partner
 */
export const useUpdatePartner = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePartner>>,
      TError,
      { partnerId: number; data: PartnerDetails },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePartner>>,
  TError,
  { partnerId: number; data: PartnerDetails },
  TContext
> => {
  const mutationOptions = getUpdatePartnerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
